import classNames from 'classnames'
import { MyIcon } from '~/components/ui/MyIcon'
import { MyBtn } from '~/components/ui/MyBtn'
import {
  AccountGroupTypeEnum,
  getAIMemberList_accountModule_userMemberCardList,
  MemberCardRightTypeEnum,
} from '~/graphqls/types'
import { toYMD, toCDNImage, groupListById, toYMDHms } from '~/utils'
import dayjs from 'dayjs'
import styles from './MemberList.module.css'
import { useState } from 'react'
import { MyLink } from '~/components/ui/MyLink'
import { useAtom } from 'jotai'
import { memberListAtom, totalInfoAtom, totalPaintPointsAtom } from './ai-form/atom'
import { useStores } from '~/hooks/useStores'
import { RechargeModal } from '../integral/RechargeModal'
import { observer } from 'mobx-react'

//3天提示到期
const TIME = 3 * 24 * 3600

export const MemberList = observer(() => {
  const [_memberList] = useAtom(memberListAtom)
  const [totalInfo] = useAtom(totalInfoAtom)
  const [totalPaintPoints] = useAtom(totalPaintPointsAtom)
  const { store } = useStores()
  const [rechargeVisible, setRechargeVisible] = useState(false)

  const memberList: getAIMemberList_accountModule_userMemberCardList[][] =
    groupListById(
      _memberList.filter(
        it => it.cardType !== AccountGroupTypeEnum.ORIGIN_CARD
      ),
      (it: getAIMemberList_accountModule_userMemberCardList) => it.cardType
    )

  // AI魔法卡
  const originCard =
    _memberList.filter(
      it => it.cardType === AccountGroupTypeEnum.ORIGIN_CARD
    )?.[0] || null

  //折叠状态
  const [collapse, setCollapse] = useState(() => {
    return Object.keys(AccountGroupTypeEnum).reduce<Record<string, boolean>>(
      (acc, cur) => {
        acc[cur] = true
        return acc
      },
      {}
    )
  })

  return (
    <div className="max-h-[564px] overflow-y-auto px-4 scrollbar">
      <div className='flex justify-center text-base font-medium mb-3'>{totalPaintPoints}积分</div>
      <MyLink
        href={`/member`}
        exist={true}
      >
        <div
          className={classNames(styles.item, 'mb-4', { vip: true })}
        >
          <div className="flex justify-between items-center text-neutral-500 font-semibold">
            <div className='text-[#FFEBCE] font-semibold text-sm mb-2'>
              无界AI VIP
            </div>
            <MyBtn
              color="primary"
              size="small"
              className="!bg-[#FFDDB4] !text-[#141416] !border-none"
            >
              立即开通
              <MyIcon icon="arrow-right" className="text-sm" />
            </MyBtn>
          </div>
          <div className="text-neutral-900 text-xs">
            {store.userinfo?.memberDetail?.hold ? toYMD(store.userinfo.memberDetail.endTime!) + ' 到期' : '开通会员获得更多权益'}
          </div>
        </div>
      </MyLink>
      <div
        className={classNames(
          styles.item,
          'border-2 border-solid border-neutral-300'
        )}
        onClick={() => setRechargeVisible(true)}
      >
        <div className='flex justify-between items-center' >
          <div className="text-[#E1E1E1] font-semibold text-sm mb-2">
            永久积分: {totalInfo?.userIntegral || 0}
          </div>
          <MyBtn
            color="primary"
            size="small"
            className="!bg-[#343946] !text-[#ffffff] !border-none"
          >
            立即充值
            <MyIcon icon="arrow-right" className="text-sm" />
          </MyBtn>
        </div>
        <div className="text-[#B0B5C4] text-xs">
          今日剩余赠送积分: {originCard?.holdCardInfo?.filter(
            it =>
              it?.rightType === MemberCardRightTypeEnum.TEMPORARY_INTEGRAL
          )?.[0]?.num || 0}
        </div>
      </div>

      {memberList?.length ? (
        <div>
          {memberList.map((cards, index) => {
            const cardType = cards?.[0]?.cardType
            let totalPaintPoints = 0
            let showEndTip = false
            cards?.map(card => {
              card?.holdCardInfo?.map(info => {
                if (
                  info?.rightType === MemberCardRightTypeEnum.TEMPORARY_INTEGRAL
                ) {
                  //其中一张到期就展示到期
                  if (!showEndTip) {
                    showEndTip = info.endTime - dayjs().unix() <= TIME
                  }
                  totalPaintPoints += info.num || 0
                }
              })
            })
            return !!collapse[cardType!] && cards?.length > 1 ? (
              <div
                className={classNames(styles.item, 'mt-4', {
                  bronzeMulti: cardType === AccountGroupTypeEnum.BRONZE_CARD,
                  silverMulti: cardType === AccountGroupTypeEnum.SILVER_CARD,
                  goldMulti: cardType === AccountGroupTypeEnum.GOLD_CARD,
                  platinumMulti:
                    cardType === AccountGroupTypeEnum.PLATINUM_CARD,
                })}
                onClick={() => {
                  setCollapse(collapse => {
                    return {
                      ...collapse,
                      [cardType!]: false,
                    }
                  })
                }}
                key={index}
              >
                <div
                  className={classNames(
                    'font-semibold flex justify-between items-center',
                    {
                      'text-[#E1E1E1]':
                        cardType === AccountGroupTypeEnum.BRONZE_CARD,
                      'text-[#B7B7B7]':
                        cardType === AccountGroupTypeEnum.SILVER_CARD,
                      'text-[#F9DEB9]':
                        cardType === AccountGroupTypeEnum.GOLD_CARD,
                      'text-[#AF94FF]':
                        cardType === AccountGroupTypeEnum.PLATINUM_CARD,
                    }
                  )}
                >
                  <div className="flex justify-start items-center">
                    <span>{cards?.[0]?.name}</span>
                    {showEndTip && (
                      <span className="text-xs bg-error rounded-full text-neutral-900 px-2 py-0.5 ml-2">
                        即将到期
                      </span>
                    )}
                  </div>
                  <MyIcon
                    icon="arrow-down-simple"
                    className="text-[20px] text-neutral-800"
                  />
                </div>
                <div className="text-neutral-900 text-xs mt-2">
                  本月可用积分:
                  <span className="text-primary mx-1">{totalPaintPoints}</span>
                </div>
              </div>
            ) : (
              <div key={index}>
                {cards?.map((card, key) => {
                  let paintPoints = 0
                  /** 剩余次数有效期，这里先默认是卡的有效期，（卡的有效期不同于剩余次数有效期，剩余次数有效期每个月重置） */
                  let endTime = card.endTime
                  card.holdCardInfo?.map(i => {
                    if (
                      i?.rightType ===
                      MemberCardRightTypeEnum.TEMPORARY_INTEGRAL
                    ) {
                      paintPoints = i.num || 0
                      endTime = i.endTime
                    }
                  })
                  return (
                    <MyLink
                      href={`/ai/equity-card?type=${card.cardType}`}
                      exist={true}
                      key={key}
                    >
                      <div
                        className={classNames(styles.item, 'mt-4', {
                          bronze:
                            card.cardType === AccountGroupTypeEnum.BRONZE_CARD,
                          silver:
                            card.cardType === AccountGroupTypeEnum.SILVER_CARD,
                          gold:
                            card.cardType === AccountGroupTypeEnum.GOLD_CARD,
                          platinum:
                            card.cardType ===
                            AccountGroupTypeEnum.PLATINUM_CARD,
                        })}
                      >
                        <div
                          className={classNames(
                            'font-semibold flex justify-between items-center',
                            {
                              'text-[#E1E1E1]':
                                card.cardType ===
                                AccountGroupTypeEnum.BRONZE_CARD,
                              'text-[#B7B7B7]':
                                card.cardType ===
                                AccountGroupTypeEnum.SILVER_CARD,
                              'text-[#F9DEB9]':
                                card.cardType ===
                                AccountGroupTypeEnum.GOLD_CARD,
                              'text-[#AF94FF]':
                                card.cardType ===
                                AccountGroupTypeEnum.PLATINUM_CARD,
                            }
                          )}
                        >
                          <div className="flex justify-start items-center">
                            <span>{card?.name}</span>
                            {endTime - dayjs().unix() <= TIME && (
                              <span className="text-xs bg-error rounded-full text-neutral-900 px-2 py-0.5 ml-2">
                                即将到期
                              </span>
                            )}
                          </div>
                          <MyBtn
                            color="primary"
                            size="small"
                            className="!bg-[#C9B9F7]/50 !text-neutral-900 !border-none"
                          >
                            立即购买
                            <MyIcon icon="arrow-right" className="text-sm" />
                          </MyBtn>
                        </div>
                        <div className="text-neutral-900 text-xs mt-2">
                          可用积分:
                          <span className="text-primary mx-1">
                            {paintPoints}
                          </span>
                          ，有效期至&nbsp;{toYMD(endTime)}
                        </div>
                      </div>
                    </MyLink>
                  )
                })}
              </div>
            )
          })}
        </div>
      ) : (
        <MyLink href={`/ai/equity-card`} exist={true}>
          <div className={classNames(styles.item, 'mt-4 platinum')}>
            <div className="text-[#AF94FF] font-semibold flex justify-between items-center">
              <div className="flex justify-start items-center">
                <img
                  className="w-5 h-5 mr-2"
                  src={toCDNImage(`/images/ai/equity/PLATINUM_CARD.svg`)}
                  alt=""
                />
                <span>AI 创作权益卡</span>
              </div>
              <MyBtn
                color="primary"
                size="small"
                className="!bg-[#C9B9F7]/50 !text-neutral-900 !border-none"
              >
                立即购买
                <MyIcon icon="arrow-right" className="text-sm" />
              </MyBtn>
            </div>
            <div className="text-neutral-900 text-xs mt-2 whitespace-nowrap">
              每月 1200 - 3600 积分，助力AI创作
            </div>
          </div>
        </MyLink>
      )}
      <RechargeModal
        visible={rechargeVisible}
        setVisible={setRechargeVisible}
      />
    </div>
  )
})
